var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 49.5,
    r: 49.5,
    fill: "#FF5A54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 30.04L48.893 23H60.8216L62.9904 25.7077H71.6658L98 60C90.4384 88.481 68.7808 95.0506 65 96L32.6266 69.5725L31 30.04Z",
    fill: "#EA494B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1949_111227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7875 23.9359C40.3781 22.7438 41.5922 22 42.9156 22H56.0844C57.4078 22 58.6219 22.7438 59.2125 23.9359L60 25.5H70.5C72.4359 25.5 74 27.0641 74 29C74 30.9359 72.4359 32.5 70.5 32.5H28.5C26.5641 32.5 25 30.9359 25 29C25 27.0641 26.5641 25.5 28.5 25.5H39L39.7875 23.9359ZM28.5 36H70.5V71C70.5 74.8609 67.3609 78 63.5 78H35.5C31.6391 78 28.5 74.8609 28.5 71V36ZM39 43C38.0375 43 37.25 43.7875 37.25 44.75V69.25C37.25 70.2125 38.0375 71 39 71C39.9625 71 40.75 70.2125 40.75 69.25V44.75C40.75 43.7875 39.9625 43 39 43ZM49.5 43C48.5375 43 47.75 43.7875 47.75 44.75V69.25C47.75 70.2125 48.5375 71 49.5 71C50.4625 71 51.25 70.2125 51.25 69.25V44.75C51.25 43.7875 50.4625 43 49.5 43ZM60 43C59.0375 43 58.25 43.7875 58.25 44.75V69.25C58.25 70.2125 59.0375 71 60 71C60.9625 71 61.75 70.2125 61.75 69.25V44.75C61.75 43.7875 60.9625 43 60 43Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1949_111227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 56,
    fill: "white",
    transform: "translate(25 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteConfirmation);
export default __webpack_public_path__ + "static/media/delete_confirmation.7a8181dc1e1a1dc771715d1db7fc5ffa.svg";
export { ForwardRef as ReactComponent };